import { cx } from './cx';

/**
 * Hairline rule. Optional centred label (e.g. "OR") sits in the line with a gap
 * on each side. Uses the border token; never a raw colour.
 */
export function Divider({ label, className }: { label?: string; className?: string }) {
  if (!label) {
    return <hr className={cx('h-px w-full border-0 bg-border', className)} />;
  }
  return (
    <div className={cx('flex items-center gap-3', className)} role="separator" aria-label={label}>
      <span className="h-px flex-1 bg-border" />
      <span className="font-body text-eyebrow uppercase tracking-[0.12em] text-text-faint">{label}</span>
      <span className="h-px flex-1 bg-border" />
    </div>
  );
}
